// extracted by mini-css-extract-plugin
export default {"container":"aboutall_container__6UqC6","item":"aboutall_item__Pkrj3","image":"aboutall_image__WJx-z","button":"aboutall_button__xDnNF"};